import { render } from "./LinkHistory.vue?vue&type=template&id=8ab293cc"
import script from "./LinkHistory.vue?vue&type=script&lang=js"
export * from "./LinkHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__